<template>
  <div>
    <v-layout class="mt-5">
      <v-flex lg12>
        <v-row class="mb-5">
          <v-col cols="12" md="2">
            <v-select
              outlined
              hide-details
              menu-props="offsetY"
              no-data-text="Opções não disponíveis"
              append-icon="arrow_drop_down"
              label="Ano Letivo*"
              :items="anos"
              v-model="form.anocardapio"
              :disabled="loading"
              :background-color="loading ? '#f2f2f2' : null"
            />
          </v-col>
          <v-col>
            <v-autocomplete
              ref="titulocardapio"
              v-model="form.identificadorcardapioescola"
              :items="cardapios"
              item-text="descricaotitulocardapio"
              item-value="identificadorcardapioescola"
              outlined
              :disabled="loading"
              :background-color="loading ? '#f2f2f2' : null"
              label="Título do Cardápio*"
              :no-data-text="cardapiosLoading ? 'Carregando dados, aguarde...' : cardapioSearch ? `Nenhuma opção encontrada com '${cardapioSearch}'` : 'Nenhuma opção carregada'"
              :search-input.sync="cardapioSearch"
              :loading="cardapiosLoading"
              loader-height="3"
              @focus="loadCardapioOptions"
              @change="onChangeCardapioOptions"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12">
            <div style="display:flex; flex-wrap: wrap;margin-bottom:10px;padding-right:4px;font-size: .93em; font-style:italic;" class="justify-sm-end">
              <span class="mr-5 mb-3 mb-sm-0">Legenda:</span>
              <ul style="margin:0; padding:0px;list-style-type: none; display:flex; flex-wrap: wrap; gap:15px;">
                <li style="display:flex;align-items:center;"><span style="display:inline-block; margin-right: 4px;width: 17px; height: 17px; border-radius: 5px;background-color:#e5f0f8;"></span>Matutino</li>
                <li style="display:flex;align-items:center;"><span style="display:inline-block; margin-right: 4px;width: 17px; height: 17px; border-radius: 5px;background-color:#f8ece5;"></span>Vespertino</li>
                <li style="display:flex;align-items:center;"><span style="display:inline-block; margin-right: 4px;width: 17px; height: 17px; border-radius: 5px;background-color:#eae5f8;"></span>Noturno</li>
                <li style="display:flex;align-items:center;"><span style="display:inline-block; margin-right: 4px;width: 17px; height: 17px; border-radius: 5px;background-color:#ecf6e4;"></span>Integral</li>
              </ul>
            </div>
          </v-col>
          <v-col cols="12">
            <v-sheet elevation="2" style="position: relative;">
              <v-toolbar flat >
                <v-btn
                  outlined
                  class="mr-4"
                  color="grey darken-2"
                  @click="data=dataDeHoje()">
                  Hoje
                </v-btn>
                <v-btn
                  fab
                  text
                  small
                  color="grey darken-2"
                  @click="prev"
                  :disabled="numeroMesSelecionado <= 1">
                  <v-icon small>
                    mdi-chevron-left
                  </v-icon>
                </v-btn>
                <v-btn
                  fab
                  text
                  small
                  color="grey darken-2"
                  @click="next"
                  :disabled="numeroMesSelecionado >= 12">
                  <v-icon small>
                    mdi-chevron-right
                  </v-icon>
                </v-btn>
                <v-toolbar-title>
                  <span class="ml-2 d-inline d-sm-none">{{ mesSelecionado[0].toLocaleUpperCase() + mesSelecionado.slice(1) }}</span>
                  <span class="ml-2 d-none d-sm-inline">{{ mesSelecionado[0].toLocaleUpperCase() + mesSelecionado.slice(1) }} de {{ form.anocardapio }}</span>
                </v-toolbar-title>
              </v-toolbar>
              <div v-show="!form.identificadorcardapioescola || loading" class="overlay"></div>
            </v-sheet>
          </v-col>
          <v-col cols="12">
            <v-progress-linear indeterminate background-color="white" color="blue darken-1" height="2" :active="loading && !loadingPopup"></v-progress-linear>
          </v-col>
          <v-col lg="12">
            <v-sheet elevation="1" style="position: relative;">
              <v-calendar
                :disabled-dates="{ weekdays: [1, 7] }"
                ref="calendar"
                color="primary"
                v-model="data"
                :weekday-format="formataNomeDiaSemana"
                :month-format="formataNomeMes"
                @click:date="mostrarPopup">
                <template v-slot:day="{ date }">
                  <div style="display: flex; flex-wrap: wrap; gap: 8px;" class="pa-sm-3 pa-1" v-if="movimentos.find(function (m) { return m.datamovimento == date})">
                    <div @click="editarMovimento(mov, $event)" v-for="mov in movimentos.filter(function (m) { return m.datamovimento == date})" :key="mov.datamovimento + mov.horacardapio" class="entrada" :class="entrada(mov.indicaturnocardapio)">
                      <v-icon v-if="1 == 2" :color="entrada_icone(mov.indicaturnocardapio)" class="mr-1 d-none d-md-inline-flex">access_time</v-icon>
                      {{ mov.horacardapio.slice(0,5) }}
                    </div>
                  </div>
                </template>
              </v-calendar>
              <v-menu
                v-model="selectedOpen"
                :close-on-content-click="false"
                :close-on-click="false"
                :activator="selectedElement"
                offset-x
              >
                <v-card color="white" width="500px" flat>
                  <v-toolbar color="teal" dark >
                    <v-toolbar-title>{{ acao == "adicionar" ? "Inserir Movimento Diário" : "Editar Movimento Diário"}}</v-toolbar-title>
                  </v-toolbar>
                  <v-card-text>
                  <v-flex lg12>
                    <v-row :class="msgArrayError ? 'pt-1' : 'pt-3'">
                      <v-col v-if="acao == 'editar'" class="mt-n1">
                        <div style="display:flex;justify-content: space-between;">
                          <v-checkbox
                            class="mt-0"
                            dense
                            v-model="podeExcluir"
                            label="Deseja excluir?"
                            color="red"
                            value="false"
                            hide-details
                            :disabled="proccessingDelete"
                          ></v-checkbox>
                          <v-btn small color="error" @click="deletarMovimento" :loading="proccessingDelete" :disabled="!podeExcluir || loadingPopup">
                            Excluir
                          </v-btn>
                        </div>
                      </v-col>
                      <v-col cols="12" v-if="msgArrayError">
                        <v-alert color="red" dense text :value="msgArrayError.length > 0" style="color: white;margin:0px !important;">
                          <div>{{ msgArrayError }}</div>
                        </v-alert>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          hide-details
                          label="Data Movimento"
                          v-model="movimento.data"
                          outlined
                          disabled
                          :background-color="'#f2f2f2'">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <Validate :v="$v.movimento.refeicao">
                          <v-select
                            slot-scope="{ props }"
                            v-bind="props"
                            outlined
                            menu-props="offsetY"
                            no-data-text="Opções não disponíveis"
                            append-icon="arrow_drop_down"
                            label="Refeição"
                            :hide-details="!$v.movimento.refeicao.$error"
                            :disabled="loadingPopup || acao == 'editar'"
                            :background-color="loadingPopup || acao == 'editar' ? '#f2f2f2' : null"
                            v-model="movimento.refeicao"
                            :items="refeicoes"
                          />
                        </Validate>
                      </v-col>
                      <v-col cols="12">
                        <Validate :v="$v.movimento.quantidadePratosServidos">
                          <v-text-field
                            slot-scope="{ props }"
                            v-bind="props"
                            label="Quantidade pratos servidos"
                            :hide-details="!$v.movimento.quantidadePratosServidos.$error"
                            :disabled="loadingPopup"
                            :background-color="loadingPopup ? '#f2f2f2' : null"
                            v-model.number="movimento.quantidadePratosServidos"
                            @input="filter"
                            outlined>
                          </v-text-field>
                        </Validate>
                      </v-col>
                      <v-col cols="12">
                        <Validate :v="$v.movimento.descricao">
                          <v-textarea
                            slot-scope="{ props }"
                            v-bind="props"
                            outlined
                            :hide-details="!$v.movimento.descricao.$error"
                            label="Descrição da Refeição Servida"
                            :disabled="loadingPopup"
                            :background-color="loadingPopup ? '#f2f2f2' : null"
                            v-model="movimento.descricao"
                          ></v-textarea>
                        </Validate>
                      </v-col>
                      <v-col cols="12">
                        <v-textarea
                          outlined
                          hide-details
                          label="Justificativa da Alteração"
                          :disabled="loadingPopup"
                          :background-color="loadingPopup ? '#f2f2f2' : null"
                          v-model="movimento.justificativa"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-flex>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn text color="secondary" @click="cancelarAdicaoMovimento" :disabled="loadingPopup || proccessingDelete">
                      Cancelar
                    </v-btn>
                    <v-btn color="teal" :dark="!proccessingDelete" @click="adicionarMovimento" :loading="loadingPopup" :disabled="proccessingDelete">
                      Salvar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            <div v-show="!form.identificadorcardapioescola || loading" class="overlay"></div>
            </v-sheet>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>

    <v-overlay color="#ffffff" :value="showOverlay" absolute></v-overlay>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000">
      {{ submitText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" icon text v-bind="attrs" @click="snackbar = false">
          <v-icon>close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
moment.locale('pt-br');
import _ from 'lodash';
import { required, integer, maxLength, maxValue } from 'vuelidate/lib/validators';
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const CardapioRepository = RepositoryFactory.get("cardapio");
const CardapioEscolaRepository = RepositoryFactory.get("cardapioEscola");
const MovimentoDiarioMerendaRepository = RepositoryFactory.get("movimentoDiarioMerenda");

export default {
  name: 'controle-diario-merenda',
  data() {
    return {
      form: {
        anocardapio: new Date().getFullYear(),
        identificadorcardapioescola: '',
        identificadortitulocardapio: '',
      },
      movimento: {
        identificadormovimentodiariomerenda: '',
        data: '',
        refeicao: '',
        quantidadePratosServidos: null,
        descricao: '',
        justificativa: '',
      },
      selectedOpen: false,
      selectedElement: null,
      data: moment().format('YYYY-MM-DD'),
      movimentos: [],
      loading: false,
      cardapios: [],
      cardapiosLoading: false,
      cardapioSearch: '',
      refeicoes: [],
      turnos: {
        'M': 'Matutino',
        'V': 'Vespertino',
        'N': 'Noturno',
        'I': 'Integral'
      },
      refeicoesCodigos: {
        '1': 'Entrada',
        '2': 'Lanche',
        '3': 'Almoço',
        '4': 'Jantar',
        '5': 'Colação',
      },
      loadingPopup: false,
      msgArrayError: '',
      snackbar: false,
      submitText: '',
      lastDateClicked: null,
      acao: '',
      podeExcluir: false,
      proccessingDelete: false,
      showOverlay: false,
    }
  },
  validations: {
    movimento: {
      data: { required },
      refeicao: {required},
      quantidadePratosServidos: { required, integer, maxValue: maxValue(1500) },
      descricao: { required, maxLength: maxLength(200)},
    }
  },
  mounted() {
    this.$Progress.finish();
  },
  computed: {
    ...mapGetters(['school']),
    anos() {
      let anos = [];
      for(let i = new Date().getFullYear(); i >= 2023; i--) {
        anos.push({ text: i, value: i });
      }
      return anos;
    },
    mesSelecionado() {
      return moment(this.data).format('MMMM')
    },
    numeroMesSelecionado(){
      return moment(this.data).format('MM')
    },
  },
  methods: {
    async loadCardapioOptions() {
      if (this.cardapios.length) {
        return
      }

      this.cardapiosLoading = true
      const { data } = await CardapioEscolaRepository.buscarCardapiosPorUnidadeEscolar(this.form.anocardapio, this.school.identificadorescolalocalexterno);
      this.cardapios = data.results;
      this.cardapiosLoading = false
    },
    async onChangeCardapioOptions() {
      this.$refs.titulocardapio.blur();
      this.loading = true;
      this.movimentos = [];
      this.data = this.dataDeHoje();
      this.form.identificadortitulocardapio = this.cardapios.find(c => c.identificadorcardapioescola == this.form.identificadorcardapioescola).identificadortitulocardapio;

      const [{data}, {data: horarios}] = await Promise.all([
        MovimentoDiarioMerendaRepository.listarMovimentos(this.form.anocardapio, this.form.identificadorcardapioescola),
        CardapioRepository.buscarHorarios(this.form.identificadortitulocardapio, this.form.anocardapio)
      ]);

      this.movimentos = data.results;
      const horariosUnicos = _.uniqBy(horarios.results, "horacardapio", "indicaturnocardapio", "indicarefeicaocardapio")
      this.refeicoes = horariosUnicos.map(h => {
        return {
          horacardapio: h.horacardapio,
          indicaturnocardapio: h.indicaturnocardapio,
          indicarefeicaocardapio: h.indicarefeicaocardapio,
          text: `${h.horacardapio} - ${this.turnos[h.indicaturnocardapio]} - ${this.refeicoesCodigos[h.indicarefeicaocardapio]}`,
          value: `${h.horacardapio}-${h.indicaturnocardapio}-${h.indicarefeicaocardapio}`
        }
      });
      this.refeicoes = _.orderBy(this.refeicoes, 'horacardapio');
      this.loading = false;
    },
    formataNomeDiaSemana(date) {
      let dias = {
        0: 'Dom',
        1: 'Seg',
        2: 'Ter',
        3: 'Qua',
        4: 'Qui',
        5: 'Sex',
        6: 'Sáb'
      }
      return dias[date.weekday];
    },
    formataNomeMes(date) {
      let meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
      return meses[date.month - 1];
    },
    dataDeHoje() {
      return moment().format('YYYY-MM-DD')
    },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },
    mostrarPopup({ nativeEvent, date }) {
      if (this.lastDateClicked != date || this.acao == 'editar') {
        this.acao = "adicionar";
        this.lastDateClicked = date;
        this.movimento.identificadormovimentodiariomerenda = '';
        this.movimento.data = moment(date).format('DD/MM/YYYY');
        this.movimento.refeicao = '',
        this.movimento.quantidadePratosServidos = null,
        this.movimento.descricao = '',
        this.movimento.justificativa = '';
        this.msgArrayError = '';
        this.$v.$reset();
      }

      this.showOverlay = true;

      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        requestAnimationFrame(() => requestAnimationFrame(() => open()))
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    },
    filter(evt) {
      this.$nextTick(() => {
        this.movimento.quantidadePratosServidos = evt.replace(/\D/, '');
      })
    },
    async adicionarMovimento() {
      this.msgArrayError = '';
      this.$v.$touch();
      if (this.$v.$invalid) return;
      this.loadingPopup = true;
      this.loading = true;
      this.podeExcluir = false;

      try {
        let [horacardapio, indicaturnocardapio, indicarefeicaocardapio] = this.movimento.refeicao.split('-');
        const { data } = this.acao == 'adicionar' ? await MovimentoDiarioMerendaRepository.inserirMovimento({
          identificadorcardapioescola: this.form.identificadorcardapioescola,
          datamovimento: this.movimento.data,
          indicaturnocardapio,
          indicarefeicaocardapio: Number.parseInt(indicarefeicaocardapio),
          horacardapio,
          quantidaderefeicaoservida: this.movimento.quantidadePratosServidos,
          descricaorefeicaoservida: this.movimento.descricao,
          justificativaalteracaorefeicaoservida: this.movimento.justificativa
        }) : await MovimentoDiarioMerendaRepository.editarMovimento({
          identificadormovimentodiariomerenda: this.movimento.identificadormovimentodiariomerenda,
          identificadorcardapioescola: this.form.identificadorcardapioescola,
          datamovimento: this.movimento.data,
          indicaturnocardapio,
          indicarefeicaocardapio: Number.parseInt(indicarefeicaocardapio),
          horacardapio,
          quantidaderefeicaoservida: this.movimento.quantidadePratosServidos,
          descricaorefeicaoservida: this.movimento.descricao,
          justificativaalteracaorefeicaoservida: this.movimento.justificativa
        });
        data.results.datamovimento = moment(data.results.datamovimento, 'DD/MM/YYYY').format('YYYY-MM-DD'),
        this.movimentos.push(data.results)
        this.movimentos = _.orderBy(this.movimentos, 'horacardapio');
        this.selectedOpen = false
        this.showOverlay = false;
        this.$v.$reset();
        this.submitText = 'Movimento salvo com sucesso.';
        this.snackbar = true;
        this.movimento = { ...this.movimento,
          identificadormovimentodiariomerenda: '',
          refeicao: '',
          quantidadePratosServidos: null,
          descricao: '',
          justificativa: '',
        }
      } catch(error) {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      } finally {
        this.loadingPopup = false;
        this.loading = false;
      }
    },
    cancelarAdicaoMovimento() {
      this.$v.$reset();
      this.msgArrayError = '';
      this.selectedOpen = false;
      this.showOverlay = false;
      this.podeExcluir= false;
      this.movimento = { ...this.movimento,
        identificadormovimentodiariomerenda: '',
        refeicao: '',
        quantidadePratosServidos: null,
        descricao: '',
        justificativa: '',
      }
    },
    editarMovimento(movimento, e) {
      this.acao = "editar";
      this.$v.$reset();
      this.msgArrayError = '';
      this.podeExcluir = false;
      this.lastDateClicked = movimento.datamovimento;
      this.selectedElement = e.target;
      this.movimento.identificadormovimentodiariomerenda = movimento.identificadormovimentodiariomerenda;
      this.movimento.data = moment(movimento.datamovimento).format('DD/MM/YYYY');
      this.movimento.refeicao = `${movimento.horacardapio}-${movimento.indicaturnocardapio}-${movimento.indicarefeicaocardapio}`;
      this.movimento.quantidadePratosServidos = Number.parseInt(movimento.quantidaderefeicaoservida);
      this.movimento.descricao = movimento.descricaorefeicaoservida;
      this.movimento.justificativa = movimento.justificativaalteracaorefeicaoservida || "";
      requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true));
      this.showOverlay = true;
      e.preventDefault();
    },
    async deletarMovimento() {
      this.msgArrayError = '';
      this.proccessingDelete = true;
      this.loading = true;

      try {
        await MovimentoDiarioMerendaRepository.deletarMovimento(this.movimento.identificadormovimentodiariomerenda);
        this.selectedOpen = false
        this.showOverlay = false;
        this.$v.$reset();
        this.submitText = 'Movimento apagado com sucesso.';
        this.snackbar = true;
        this.movimentos = this.movimentos.filter(m => m.identificadormovimentodiariomerenda != this.movimento.identificadormovimentodiariomerenda);
        this.movimento = { ...this.movimento,
          identificadormovimentodiariomerenda: '',
          refeicao: '',
          quantidadePratosServidos: null,
          descricao: '',
          justificativa: '',
        }
        this.podeExcluir = false;
      } catch(error) {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      } finally {
        this.proccessingDelete = false;
        this.loading = false;
      }
    },
    entrada(turno) {
      return `entrada-${turno}`
    },
    entrada_icone(turno) {
      let cor = {
        'M': '#4c98ce',
        'V': '#ce7b4c',
        'N': '#6e4cce',
        'I': '#7cc146',
      }
      return cor[turno];
    }
  }
}
</script>

<style scoped>
.entrada {
  box-sizing: border-box;
  /* border: 0px solid rgb(61, 174, 235);
  border-left-width: 2px !important; */
  border-radius: 4PX;
  padding: 4px 0px;
  color: rgb(93, 93, 93);
  font-weight: bold;
  font-size: 14px;
  text-align: center;
  width: 100%;
}
.entrada:hover {
  cursor: pointer;
}
.entrada-M {
  background-color: #e5f0f8 !important;
}
.entrada-V {
  background-color: #f8ece5 !important;
}
.entrada-N {
  background-color: #eae5f8 !important;
}
.entrada-I {
  background-color: #ecf6e4 !important;
}
.overlay{
  background: rgba(255,255,255,0.44);
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
}

@media only screen and (min-width: 960px){
  .entrada {
    width: calc(50% - 4px);
  }
}

::v-deep textarea {
  resize: none !important;
}

::v-deep .v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0px !important;
}
</style>
